import React, { Component, PropType } from 'react'
import ReactDOMServer from 'react-dom/server';
import PopoverComponent from './PopoverComponent';
import Form from '../../../../adminpanel/components/commonComponents/Form.v2';
import ModalComponent from '../../../../adminpanel/components/commonComponents/ModalComponent';

var toolTipCSS = {
    color: 'black ! important',
    display: 'inline-block ! important',
    padding: '0px'
};

var tr_style = {
    borderBottom: "solid 1px rgb(166, 166, 166)"
};

var growthStyle = {};
var targetGapInfo
class SummaryMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            toolTip: props.toolTip,
            metric: props.data.metric,
            breakup: props.breakup,
            metricGlobal: props.metricGlobal,
            metricFunction: props.metricFunction,
            property: props.property,
            periodComparison: props.periodComparison,
            startDate: props.startDate,
            endDate: props.endDate,
            growthStartDate: props.growthStartDate,
            growthEndDate: props.growthEndDate,
            outputType: props.outputType,
            componentData: props.componentData,
            summaryShortName: props.summaryShortName
        };
    }
    // show_more: function(id) {
    //     if(document.getElementById("show_more" + id).innerHTML=="Show More"){
    //         document.getElementById("show_more"+id).innerHTML="Hide";
    //         growthStyle={display:"none"};
    //     }
    //     else {
    //         document.getElementById("show_more"+id).innerHTML="Show More";
    //         growthStyle={};
    //     }
    //     this.forceUpdate();
    // },
    trendHandle = (e) => {
        this.setState({
            trendMetric: e
        })
    }
    siderBarHandle = (e) => {
        openSidebar('alertTab');
    }
    onPopoverClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    toggleModal = (metricValue) => {
        jQuery("#pin_handle").modal("show");
        pin_metric_value = metricValue;
    }
    componentDidMount() {
        jQuery('[data-toggle="tooltip"]').tooltip();
        feather.replace()
        // jQuery('[data-toggle="popover"]').popover();
        if (this.props.pop_over) {
            jQuery('#show_more' + this.props.id).popover('show');
        }
    }
    componentWillUnmount() {
        jQuery(".popover").popover('dispose');
    }
    handleClick(e) {
        this.setState({ target: e.target, show: !this.state.show });
    }
    render() {
        var startDate = this.state.startDate;
        var endDate = this.state.endDate;
        var growthStartDate = this.state.growthStartDate;
        var growthEndDate = this.state.growthEndDate;
        var metricData = this.state.data.metricData ? this.state.data.metricData : this.state.data.metric;

        /* Enabled CF of Actual Value */
        let metricColor;
        // let metricColor = 'black';
        if (metricData && metricData.information) {
            metricColor = isJson(metricData.information) && JSON.parse(metricData.information)['metricColor'] ? JSON.parse(metricData.information)['metricColor'] : metricData.information.metricColor ? metricData.information.metricColor : metricColor
        }
        let isPositive = metricData && metricData.isPositive == '0' ? 0 : 1
        var outputType = this.state.outputType;
        var additional_table = null;
        var extra_KPI = this.state.data.allData['extraMetrics'];
        var extra_kpi_value = null
        var extra_kpi_valueRaw = null
        var shortNameObj = this.state.summaryShortName
        let ExportComponentVar = null;
        let insightSortOrder = getInsightSortOrder(this.state.data.allData, this.state.data.metric)

        let modalConfig = {
            "exportSettings": {
                "id": `exportSettings_${this.props.index}`, "form_name": "exportSettings", "title": "Export", "body": null, "buttonType": "submit", "button_name": "Export", "display": true
            }
        }
        // Export Options
        var exportOptions;
        exportOptions = [{ "name": "Excel", "value": "xls" }, { "name": "CSV", "value": "csv" }]

        let formData = {
            "exportFileName": { "name": `exportFileName_`, "label": "File Name", "type": "text", requiredFlag: true },
            "exportType": {
                "name": `exportType_${this.props.index}`, "label": "Export Type", "type": "dropdown", "options": exportOptions, requiredFlag: true
            }
        }

        var Form_Data = <Form label_array={formData} />;
        modalConfig['exportSettings']['body'] = Form_Data;
        modalConfig['exportSettings']['formKey'] = `export_${Math.floor(Math.random() * 10)}`;
        ExportComponentVar = (<ModalComponent modalConfig={modalConfig["exportSettings"]} />)
        let popover_config = { "name": "Info", "icon": "fas fa-info-circle", "position": "bottom", "id": ("show_more" + this.state.metric), "content": "", "title": "" };

        if (!this.state.data.metricData)
            metricData = refineData(metricData, this.props.mainMetric ? this.props.mainMetric : metricGlobal, metricFunction);

        metricData = metricData ? changeNumberFormat(metricData, propertyMain) : ''

        if (showSummaryGrowth && extra_KPI) {
            //handle metricunit
            var pre_fix_unit = '';
            var su_fix_unit = '';
            if (metricData.metricUnit)
                if (metricData.metricPrefix == 'true')
                    pre_fix_unit = metricData.metricUnit;
                else su_fix_unit = metricData.metricUnit;

            //handle metricunit end            
            var that = this;
            var extra_KPI_ARRAY = extra_KPI.map(function (innerData) {
                var tempData = refineData(innerData, that.props.mainMetric ? that.props.mainMetric : metricGlobal, metricFunction);
                return tempData;
            });
            // var additional_table=;
            var tr_data = [];
            extra_KPI_ARRAY.map(function (innerData, index) {
                if (innerData && that.state.data.allData[innerData.value]) {
                    //handle metricunit
                    var pre_fix_unit = '';
                    var su_fix_unit = '';
                    if (innerData.metricUnit)
                        if (innerData.metricPrefix == 'true')
                            pre_fix_unit = innerData.metricUnit;
                        else su_fix_unit = innerData.metricUnit;

                    //handle metricunit end
                    extra_kpi_valueRaw = that.state.data.allData[innerData.value]
                    var value = extra_kpi_value = pre_fix_unit + " " + number_shorten(extra_kpi_valueRaw, innerData.roundOff, innerData.numberShorten) + " " + su_fix_unit;
                    tr_data.push(<tr style={tr_style} key={'information_' + index + '_' + that.props.id}><td>{innerData.label}</td><td className='table_values'>{value}</td></tr>);
                }
            })
            if (this.state.data.allData.previous_value) {
                var previous_value_label = getPreviouValueLabelBasedOnPeriodComparison(this.state.periodComparison);
                var previous_temp_value = pre_fix_unit + " " + number_shorten(that.state.data.allData.previous_value, metricData.roundOff, metricData.numberShorten) + " " + su_fix_unit;

                tr_data.push(<tr style={tr_style} key={'information_previous' + that.props.id}><td>{previous_value_label}</td><td className='table_values'>{previous_temp_value}</td></tr>);
            }
            if (this.state.data.allData.growth && this.state.data.allData.growth != "N.A.") {
                var span_color = this.state.data.allData.growth < 0 ? 'tx-medium tx-danger' : 'tx-medium tx-success';
                var tempvalue = Math.abs(this.state.data.allData.growth);

                // var value_sign_icon=span_color=="text-red"?'fa  fa-caret-down text-error':'fa  fa-caret-up text-success';
                var value_sign_icon = span_color == "tx-medium tx-danger" ? 'icon ion-md-arrow-down' : 'icon ion-md-arrow-up';

                tr_data.push(<tr style={tr_style} key={'information_growth' + that.props.id}>
                    <td>Growth Rate</td><td className={'table_values ' + span_color}>{tempvalue + "% "}<i className={value_sign_icon}></i></td></tr>);
            }
            if (this.state.data.allData.absolute) {
                // var span_color=that.state.data.allData.absolute<0?'text-red':'text-green';
                var span_color = that.state.data.allData.absolute < 0 ? 'tx-medium tx-danger' : 'tx-medium tx-success';
                var absolute_temp_value = Math.abs(that.state.data.allData.absolute);

                var absolute_temp_value = pre_fix_unit + " " + number_shorten(absolute_temp_value, metricData.roundOff, metricData.numberShorten) + " " + su_fix_unit;

                // var value_sign_icon=span_color=="text-red"?'fa  fa-caret-down text-error':'fa  fa-caret-up text-success';
                var value_sign_icon = span_color == "tx-medium tx-danger" ? 'icon ion-md-arrow-down' : 'icon ion-md-arrow-up';

                tr_data.push(<tr style={tr_style} key={'information_absolute' + that.props.id}><td>Absolute Change</td><td className={'table_values ' + span_color}>{absolute_temp_value}<i className={value_sign_icon}></i></td></tr>);

                // tr_data.push(<tr key={"information_absolute"+this.props.id}><td>{"Absolute Change"}</td><td className={"table_values "+span_color}><i className={value_sign_icon}></i>{" "+absolute_temp_value}</td></tr>);
            }
            // Comment here
            if (this.state.data.allData.runrate) {
                var span_color = that.state.data.allData.runrate < 0 ? 'text-red' : 'text-green';
                var runrate_temp_value = Math.abs(that.state.data.allData.runrate);
                var runrate_temp_value = pre_fix_unit + " " + number_shorten(runrate_temp_value, metricData.roundOff, metricData.numberShorten) + " " + su_fix_unit;
                var value_sign_icon = span_color == "text-red" ? 'fa  fa-caret-down text-error' : 'fa  fa-caret-up text-success';

                tr_data.push(<tr style={tr_style} key={'information_absolute' + that.props.id}><td>{this.props.runrateGran + " Runrate needed for " + this.props.runrateYear}</td><td className={'table_values ' + span_color}>{runrate_temp_value}</td></tr>);
            }
            if (this.state.data.allData.projection) {
                var span_color = this.state.data.allData.projection < 0 ? 'text-red' : 'text-green';
                var tempvalue = Math.abs(this.state.data.allData.projection);
                var value_sign_icon = span_color == "text-red" ? 'fa  fa-caret-down text-error' : 'fa  fa-caret-up text-success';

                tr_data.push(<tr style={tr_style} key={'information_growth' + that.props.id}><td>Projected Achievement</td><td className={'table_values ' + span_color}><i className={value_sign_icon}></i>{" " + tempvalue + " %"}</td></tr>);
            }
            additional_table = <table style={{ padding: "10px" }}>{tr_data}</table>;
        }
        // if insight enable remove growth value
        if (this.props.insightStyle == true || this.props.insightStyle == 2)
            growthStyle = { display: "none" };

        var metric = metricData.label ? metricData.label : this.state.data.metric;

        if (metricData.shortName && isJson(metricData.shortName)) {
            metricData.shortName = JSON.parse(metricData.shortName)
            metricData.shortName = metricData.shortName && metricData.shortName[metricData.currentFunction] ? metricData.shortName[metricData.currentFunction] : (metricData.shortName && metricData.shortName["default"] ? metricData.shortName["default"] : null)
        }

        // metric = metricData.shortName && this.props.isDashboard ? metricData.shortName : metric;
        metric = metricData.shortName && this.props.dashboard && shortNameDisplayFlag && shortNameDisplayFlag.summary ? metricData.shortName : metric;

        if (outputType == 'runrate;0' || outputType == 'runrate;1' || outputType == 'projection') {
            metric = this.state.data.description;
            //     var metricValue = '';
            //     var metricRoundOff = 2;
            //     // var metricNumberShorten = outputType == 'projection' ? 'in' : 'l';
            //     var metricNumberShorten = 'C';
            //     // var metricUnit =  outputType == 'projection' ? '%' : '';
            //     var metricUnit =  '';
            //     var metricPrefix = '';
        }
        if (this.props.previousValue) {
            metric = 'Previous ' + metric;
        }
        var metricValue = metricData.value;
        var metricRoundOff = metricData?.value?.includes('cagr') ? "2" : metricData.roundOff;
        var metricNumberShorten = metricData?.value?.includes('cagr') ? "%" : metricData.numberShorten;
        var metricUnit =  metricData?.value?.includes('cagr') ? "%" :  metricData.metricUnit;
        var metricPrefix = metricData.metricPrefix;
        var metricInformation = metricData.information;
        // if(metricInformation) {            
        //     metricInformation = jQuery.parseJSON(metricInformation);                                
        // }        
        var newDataFull = 0;
        var newData = 0;
        var shareMetricValue = 'N.A.';
        var backgroundColor = {};
        if (this.state.data.data) {
            var metricActualData = this.state.data.allData;
            /* Enabled CF of Actual Value */
            metricColor = metricColor ? metricColor : metricInformation && metricActualData ? handleConditionalFormatting(metricActualData, metricInformation, metricValue.split(';')[1], backgroundColor, 'summary') : metricColor;
            if (metricActualData == shareMetricValue) {
                newDataFull = shareMetricValue;
                newData = shareMetricValue;
                metricUnit = ''; // No need to have metricUnit in case of N.A.
            } else {
                newDataFull = number_shorten(metricActualData.data, metricRoundOff, metricNumberShorten);
                newData = delimitNumbersIndianFormat(metricActualData.data, metricRoundOff);
            }
        }
        if (this.state.data.absolute) {
            var absoluteFull = number_shorten(Math.abs(this.state.data.absolute), metricRoundOff, metricNumberShorten);/*absolute value is sent for formatting*/
            var absoluteData = delimitNumbersIndianFormat(this.state.data.absolute, metricRoundOff);
        } else {
            var absoluteFull = null
            var absoluteData = null;
        }

        var breakup = this.state.breakup;
        var growth = '';
        var growthData = !this.props.hideGrowth ? '' : this.state.data.growth;
        var toolTip = '';

        if (this.state.toolTip) {
            toolTip = <a href="#" id="summaryTooltip" style={toolTipCSS} data-toggle="tooltip" title={this.state.toolTip}><i className='icon-info-sign' style={{ color: 'black' }}></i></a>;
        }

        var absolute_style = null;
        var periodComparison = getPeriodForGrowth(this.state.periodComparison);
        // if(!extra_KPI && metricUnit!=="%"){
        if (growthData == '(' + shareMetricValue + ')' || growthData == shareMetricValue) {
            var growthTitle = null;
            var absoluteFull = null
            var absoluteData = null;
            growthData = growthData == shareMetricValue ? '' : growthData;
            growth = <label className='tx-error growthStyle'>{growthData} <a href="#" style={toolTipCSS} data-toggle="tooltip" title='Growth Rate not applicable.'><i className='icon-info-sign' style={{ color: 'black' }}></i></a></label>
        } else if (!growthData && (growthData !== 0)) {
            var growthTitle = '';
            growth = '';
        }
        else {
            if (growthData < 0) {
                var growth_class = 'tx-medium tx-danger';
                var value_sign_icon = 'icon ion-md-arrow-down';
            } else {
                var growth_class = 'tx-medium tx-success';
                var value_sign_icon = 'icon ion-md-arrow-up';
            }
            var growthTitle = "Growth Rate (" + growthData + " %) for (" + moment(startDate).format('MMM DD, YYYY') + " - " + moment(endDate).format('MMM DD, YYYY') + ") compared to (" + moment(growthStartDate).format('MMM DD, YYYY') + " - " + moment(growthEndDate).format('MMM DD, YYYY') + ") i.e, " + periodComparison;

            growthData = growthData[0] === '-' ? growthData.substr(1) : growthData;
            // starts here
            // growth = <label className={growth_class}>
            //     [GR: <i className={value_sign_icon}></i> {growthData} %]
            //     <a href='#' onClick={this.onPopoverClick} data-toggle="popover" data-content={growthTitle} data-placement="bottom" style={{ margin: '3px' }}><i className="fa fa-question-circle" style={{ color: 'black' }}></i></a>
            // </label>
            growth = <span className={growth_class}>
                {growthData}% <i className={value_sign_icon}></i></span>

            {/* <a href='#' onClick={this.onPopoverClick} data-toggle="popover" data-content={growthTitle} data-placement="bottom" style={{ margin: '3px' }}><i className="fa fa-question-circle" style={{ color: 'black' }}></i></a> */ }
        }
        absolute_style = growthData ? { marginLeft: '20px' } : {};
        // }
        //  else {
        //     growthData = '';
        //     growth = <label className='tx-error growthStyle'>{growthData} <a href="#" style={toolTipCSS} data-toggle="tooltip" title='Growth Rate not applicable.'><i className='icon-info-sign' style={{ color: 'black' }}></i></a></label>
        // }

        /*Absolute change value*/
        if (!extra_KPI && absoluteFull && this.props.isDashboard != true) {
            if (metricUnit) {
                if (metricPrefix == 'true') {
                    absoluteFull = metricUnit + ' ' + absoluteFull;
                    absoluteData = metricUnit + ' ' + absoluteData;
                } else {
                    absoluteFull = absoluteFull + ' ' + metricUnit;
                    absoluteData = absoluteData + ' ' + metricUnit;
                }
            } else {
                absoluteFull = absoluteFull;
                absoluteData = absoluteData;
            }
            var absolute_value_class = growth_class + ' growthStyle';
            var absoluteTitle = "Absolute Change (" + absoluteData + ") for (" + moment(growthStartDate).format('MMM DD, YYYY') + " - " + moment(growthEndDate).format('MMM DD, YYYY') + ") i.e, " + periodComparison;

            absoluteFull = <label className={absolute_value_class} style={absolute_style}>[AC: <i className={value_sign_icon}></i> {absoluteFull}]
                <a href='#' id="showButton" onClick={this.onPopoverClick} data-toggle="popover" data-html='true' data-content={absoluteTitle} data-placement="bottom" style={{ margin: '3px' }}><i className="fa fa-question-circle" style={{ color: 'black' }}></i></a>
            </label>
        } else {
            absoluteFull = null;
        }
        /*Change of Absolute change value*/

        /*Actual Data to display*/
        if (metricUnit)
            if (metricPrefix === 'true')
                newDataFull = metricUnit + ' ' + newDataFull;
            else newDataFull = newDataFull + ' ' + metricUnit;
        else newDataFull = newDataFull;

        let extraData = '';
        if (extra_kpi_value) {
            let arrow = null
            let textClass = null
            if (extra_kpi_valueRaw < 0) {
                textClass = 'text-danger'
                arrow = <i className={"fa fa-arrow-down" + textClass} aria-hidden="true"></i>
            } else {
                textClass = 'text-success'
                arrow = <i className={"fa fa-arrow-up" + textClass} aria-hidden="true"></i>
            }
            extraData = <span className={textClass} style={{ fontSize: '12px' }}><i className={"fa fa-arrow-up" + textClass} aria-hidden="true"></i>( {extra_kpi_value})</span>

            /* Commented extra data addition to newDataFull at the time when summary block modifications implemented */
            // newDataFull = <span className='title text-contrast' id="titleTip" style={summaryFontSize} data-placement="right">{newDataFull} {extraData}</span>;
            newDataFull = <span className='title text-contrast' id="titleTip" style={summaryFontSize} data-placement="right">{newDataFull}</span>;
        } else {
            newDataFull = <span className='title text-contrast' id="titleTip" style={summaryFontSize} data-placement="right">{newDataFull}</span>;
        }
        /*end of Actual Data to display*/

        var trendMetric, trendURL = null;
        if (metricValue != undefined) {
            trendMetric = metricValue;
            // var trendProperty = this.state.property ? this.state.property : (main_property_array && main_property_array[0] ? main_property_array[0].value : null);
            var trendProperty = this.state.property;
            var trendPropertySplit = trendProperty && trendProperty != undefined ? trendProperty.split(';') : '';
            trendProperty = trendProperty && trendPropertySplit[1] ? trendProperty : 'null';
            var trendBreakup = refineURLData(breakup) ? breakup : '';            
            trendBreakup = trendProperty != 'null' ? (trendProperty + ',' + trendBreakup).replace(/,+$/,'') : trendBreakup;
            // trendBreakup += trendPropertySplit[1] ? this.state.property : '';
            let tempStartDate = moment(startDate, "YYYY-MM-DD").format('YYYY-MM-DD');
            let tempEndDate = moment(endDate, "YYYY-MM-DD").format('YYYY-MM-DD');
            let dateDiff = moment(tempStartDate, 'YYYY-MM-DD').diff(moment(tempEndDate, 'YYYY-MM-DD'), 'days');
            trendURL = window.location.origin + '/chart/chartData?property=' + trendProperty + '&propertyValues=null&metric=' + trendMetric + '&breakup=' + trendBreakup + "&include=" + this.props.include + "&exclude=" + this.props.exclude + '&startDate=' + startDate + '&endDate=' + endDate + '&period=' + setPeriod(dateDiff);
            trendURL += '&chartType=&chartStyle=Line&getAnomlyDetection=false&chartCat=Line';
        }
        var iconDispStyle = { cursor: 'pointer', padding: '0px 5px 0px 0px', fontSize: "17px", color: "black" };
        var iconDispStyleDash = { cursor: 'pointer', marginRight: '10px' };

        var pin = null;
        var deepInsight_handle = null;

        // var insight_handle = this.props.drillHandle ? <a className="insight_handle_class" data-toggle="tooltip" onClick={this.props.drillHandle.bind(this,metricValue,'insight')} data-placement="bottom" data-original-title='Auto Analyse' id={'insight_handle_button_summary_'+metricValue}> <i className="far fa-lightbulb desc-btn"></i> </a> : null;
        // var insight_handle = this.props.drillHandle ? <a className="dropdown-item details" onClick={() => { this.props.drillHandle.call(this, metricValue, null, 'insight', metricValue, null, null, null, this.props.componentData, insightSortOrder) }} id={'insight_handle_button_summary_' + metricValue} style={{ cursor: 'pointer' }}><i className="far fa-lightbulb pd-r-5"></i>Auto Analysis</a> : null;    
        var insight_handle = this.props.drillHandle ? <a className="dropdown-item details" onClick={() => { this.props.drillHandle.call(this, metricValue, null, 'insight', metricValue, null, null, null, this.props.componentData, insightSortOrder) }} id={'insight_handle_button_summary_' + metricValue} style={{ cursor: 'pointer' }}><i className="far fa-lightbulb pd-r-5"></i>Auto Analysis</a> : null;    

        
        // var insight_handle =  null;
        // deepInsight_handle = this.props.drillHandle ? <a className="dropdown-item details" onClick={() => { this.props.drillHandle.call(this, metricValue, null, 'deepInsight', metricValue, null, null, null, this.props.componentData) }} id={'deepInsight_handle_button_summary_' + metricValue} style={{ cursor: 'pointer' }}><i className="far fa-lightbulb pd-r-5"></i>Root Cause Analysis</a> : null;

        if (this.props.pinFilter) {
            // pin = <a href="#" className="pin_handle_class" data-toggle="tooltip" id={"summary_pin_"+metricValue} data-placement="bottom" data-original-title="Pin to Dashboard" onClick={this.toggleModal.bind(this,metricValue)}>
            //         <i className="fas fa-thumbtack  desc-btn"></i>
            //     </a>;
            pin = <a className="dropdown-item details" id={"summary_pin_" + metricValue} onClick={this.toggleModal.bind(this, metricValue)} style={{ cursor: 'pointer' }}><i className="fas fa-thumbtack pd-r-5"></i>Pin to Dashboard</a>
        }

        var classBoxStyle = {};
        if (this.props.isDashboard) {
            if (this.props.isDashboard == 1)
                var classBox = 'box col-sm-12';
            else if (this.props.isDashboard == 2)
                var classBox = 'box col-sm-6';
            else if (this.props.isDashboard == 3)
                var classBox = 'box col-sm-4';
            else if (this.props.isDashboard == 4)
                var classBox = 'box col-sm-3';
        }
        else if (this.props.recommendation == true) {
            var classBox = 'box col-md-12';
            var iconDispStyle = { display: 'none' };
            var iconDispStyleDash = { display: 'none' };
            let itemData = this.props.componentData
            var editSummary = checkIfFeatureApplicable('Edit Dashboard Component Name') && metricData ? <a className="dropdown-item" onClick={() => this.props.componentData.handleEditComponent(itemData.itemDetails, itemData.startDate, itemData.endDate, itemData.property_disp, itemData.includeDisp, itemData.excludeDisp, itemData.selectedMetricDisp, itemData.selectedBreakUpDisp)}><i class="fas fa-edit pd-r-5"></i>Edit Component</a> : ''
            var openInNewTab = checkIfFeatureApplicable('Open In New Tab Dashboard') && metricData ? <><a className="dropdown-item" target="_blank" href={this.props.componentData.openInNewTabURL} ><i class="fas fa-plus pd-r-5"></i>Open In New Tab</a></> : ''
            var deleteSummary = checkIfFeatureApplicable('Delete Dashboard Component') ? <a className="dropdown-item" onClick={this.props.componentData.deletePin.bind(this, this.props.index)} ><i class="fas fa-minus pd-r-5"></i>Delete</a> : ''
            var exportSummary = checkIfFeatureApplicable('Download') && metricData ? <a className="dropdown-item" data-bs-toggle="modal" href={`#exportSettings_${this.props.index}`} id={`exportSettingHandleButton_${this.props.index}`}><i class="fas fa-arrow-down pd-r-5"></i> Export</a> : ''
        } else if (this.props.spikeNewPageStyle == 2) {
            var iconDispStyle = { display: 'none' };
            var classBox = 'box md-2';
        } else if (this.props.insightStyle == true) {   // When Insight opens in sidebar
            var classBox = 'box md-2';
        } else if (this.props.insightStyle == 2 || this.props.spikeNewPageStyle == true || defaultFilterFlag == '1' || this.props.insightPoint || this.props.insight) {   // When Insight comes opens in new tab                        
            // var classBox = this.props.insightSummary ? 'col-sm-11 mg-t-12 mg-sm-t-0' : 'col-sm-6 col-lg-4 mg-t-10 mg-sm-t-0';
            var classBox = this.props.insightSummary ? 'col-sm-6 col-lg-6 mg-t-10 mg-sm-t-0' : 'col-sm-6 col-lg-4 mg-t-10 mg-sm-t-0';
            classBoxStyle = this.props.insightSummary ? { padding: '0px', paddingLeft: '0px', paddingBottom: '15px', paddingRight: '8px' } : { padding: '0px', paddingLeft: '2px' }
        } else {
            var classBox = 'col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0';
        }
        if (this.props.hideChart) {
            var trendChartIcon = null;
            var summaryFontSize = { marginTop: "5px" };
        }
        else if (this.props.growth == true) {
            var trendChartIcon = null;
            var summaryFontSize = { fontSize: '25px' };
        } else {
            // Enable View trend on right click for dashboard
            if (pinHandleFunction) {
                // var trendChartIcon = <div className="aside-alert-link">
                //     {/* {<div style={{ overflow: 'auto' }}><span className="float-right">} */}
                //     {/*<a onClick={pinHandleFunction.bind(this, metricData.value)} style={iconDispStyleDash}><i className="fas fa-thumbtack" title="Pin to Dashboard" data-toggle="tooltip" data-placement="bottom"></i></a>*/}
                //     {pin}
                //     <a href={trendURL} className="" id={"summary_trend_"+metricValue} target="_blank" data-toggle="tooltip" data-placement="bottom" data-original-title="View Trend" >
                //         <i className="fas fa-chart-bar desc-btn"></i>
                //     </a>
                //     {insight_handle}
                // </div>;
                // <a style={{ fontSize: "13px", color: "#337ab7", cursor: "pointer", padding: "0px" }} id={"show_more" + this.state.metric} onClick={this.handleClick}> Show More</a>;
                var trendChartIcon =
                    <div className="dropdown-file">
                        <a id={"dropdown" + metricValue} href="#" className="dropdown dropdown-link" data-bs-toggle="dropdown" >
                            <i aria-expanded="false" data-feather="more-vertical"></i>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end">
                            {checkIfFeatureApplicable('Pin To Dashboard') ? pin : ''}
                            <a href={trendURL} id={"summary_trend_" + metricValue} target="_blank" className="dropdown-item details" ><i className="fas fa-chart-bar pd-r-5"></i>View Trend</a>
                            {checkIfFeatureApplicable('Insight') ? insight_handle : ''}
                            {checkIfFeatureApplicable('Root Cause Analysis') ? deepInsight_handle : ''}
                        </div>
                    </div>;
            } else var trendChartIcon = <div className=" dropdown-file">
                <a id={"dropdown" + metricValue} href="#" className="dropdown dropdown-link" data-bs-toggle="dropdown"  >
                    <i aria-expanded="false" data-feather="more-vertical"></i>
                </a>
                <div className="pinboard-summary-box dropdown-menu dropdown-menu-end" style={{ maxHeight: '90px', overflowY: window.location.pathname == "/summary" ? null : 'scroll' }}>
                    {checkIfFeatureApplicable('Pin To Dashboard') ? pin : ''}
                    {metricData ? <a href={trendURL} className="dropdown-item details" id={"summary_trend_" + metricValue} target="_blank">
                        <i className="fas fa-chart-bar pd-r-5"></i>View Trend</a> : ''}
                    {checkIfFeatureApplicable('Insight') && metricData ? insight_handle : ''}
                    {checkIfFeatureApplicable('Root Cause Analysis') && metricData ? deepInsight_handle : ''}
                    {editSummary}
                    {openInNewTab}
                    {exportSummary}
                    {deleteSummary}
                </div>
            </div>;
            // else var trendChartIcon = <div className="aside-alert-link">
            //     {/* <div style={{ overflow: 'auto' }}><span className="float-right"> */}
            //     {pin}
            //     <a href={trendURL} className="float-right" id={"summary_trend_"+metricValue} target="_blank" data-placement="bottom" data-original-title="View Trend" data-toggle="tooltip" >
            //         <i className="fas fa-chart-bar desc-btn"></i></a>
            //     {insight_handle}
            // </div>;
            var summaryFontSize = { marginTop: "5px" };
        }

        if (newDataFull == 'NaNaN')
            newDataFull = '';
        if (this.props.spikeNewPageStyle) {
            //, width: '77%', marginLeft:'11%' 
            var style = { borderLeft: "2px solid " + colorArray[Math.floor(Math.random() * colorArray.length)] };
            // var mainStyle = this.props.id == 0 ? {margin: 'auto'} : {};
            // var mainStyle = {margin: '0px 0px 20px 0px'};
            if (this.props.spikeNewPageStyle == 2)
                var mainStyle = { margin: '0px 0px 20px 0px', minHeight: "140px", padding: '0px' };
            else var mainStyle = { margin: '0px 0px 20px 0px', minHeight: "140px" };
            // var mainStyle = {width:'44.2%', marginLeft:'3.8%'};
        } else {
            var style = { borderLeft: "2px solid " + colorArray[Math.floor(Math.random() * colorArray.length)], minHeight: '160px' };
            var mainStyle = this.props.insightStyle == true ? { width: '109%', marginLeft: '-16px' } : {};
        }

        var addition_data = null;
        if (additional_table) {
            // additional_table=<a style={{fontSize:"13px",color:"#337ab7",cursor:"pointer",padding:"0px"}} data-html="true" id={"show_more"+this.props.id} onClick={this.onPopoverClick} data-toggle="popover" data-original-title="More Information" data-content={additional_table} data-placement="bottom"> Show More</a>;
            addition_data = additional_table;
            additional_table = <a style={{ fontSize: "13px", color: "#337ab7", cursor: "pointer", padding: "0px" }} id={"show_more" + this.state.metric} onClick={this.handleClick}>Show More</a>;
            // addition_data=additional_table;
        }
        else additional_table = null;

        let pointerClass = this.props.index || tr_data ? null : 'summaryPointer';

        popover_config.className = null;

        // renderToStaticMarkup function converts JSX to static HTML

        popover_config.content = tr_data ? ReactDOMServer.renderToStaticMarkup(<table style={{ padding: "10px" }}>{tr_data}</table>) : null;

        popover_config.html_data = <h3 className={`tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 ${pointerClass}`}>{newDataFull}</h3>

        // if(this.props.isDashboard==true)
        //     trendChartIcoinn=null;        

        // if (this.props.dashboard !== true) {
        resetFilterGo();
        // }

        var targetGapValue = null, actualValue = null, planValue = null, targetLabel = null, targetLabelIcon = null, growthValue = null, LMValue = null, targetGapValueColor = null, extraMetricsInfo = [], varianceInfo = []
        if (extra_KPI && shortNameObj) {
            Object.keys(shortNameObj).map(function (innerVal) {
                if (innerVal === metricData?.value?.split(';')[0]) {
                    actualValue = that.state.data.allData[shortNameObj[innerVal]['Actual']]
                    targetGapValue = that.state.data.allData[shortNameObj[innerVal]['Target Gap']]
                    planValue = that.state.data.allData[shortNameObj[innerVal]['Plan']]
                    growthValue = that.state.data.allData[shortNameObj[innerVal]['LM Growth']] || that.state.data.allData[shortNameObj[innerVal]['Growth Rate']] || that.state.data.allData[shortNameObj[innerVal]['Growth']]
                    LMValue = that.state.data.allData[shortNameObj[innerVal]['Last Month']] || that.state.data.allData[shortNameObj[innerVal]['Previous Year']] || that.state.data.allData[shortNameObj[innerVal]['Last Month Actual']]

                    // actualValue = actualValue ? actualValue : newData
                    let newActualValue = actualValue ? actualValue : newData
                    // let onePercentVal = parseFloat(calculateOnePercent(planValue).toFixed(metricData.roundOff))
                    // let negativeOnePercent = planValue - onePercentVal
                    // onePercentVal = planValue + onePercentVal

                    // let upCase1 = targetGapValue <= onePercentVal && targetGapValue >= negativeOnePercent
                    // let upCase2 = targetGapValue > onePercentVal 

                    // if (targetGapValue < negativeOnePercent) {

                    if ((planValue == undefined || planValue == null) && LMValue) {
                        if (newActualValue >= LMValue) {
                            if (isPositive) {
                                targetLabelIcon = 'fa fa-arrow-up'
                                targetGapValueColor = '#309143'
                            } else {
                                targetLabelIcon = 'fa fa-arrow-up'
                                targetGapValueColor = '#ff0000'
                            }
                            // targetGapValueColor = isPositive ? '#309143' : '#ff0000'
                        } else if (newActualValue < LMValue) {
                            if (isPositive) {
                                targetLabelIcon = 'fa fa-arrow-down'
                                targetGapValueColor = '#ff0000'
                            } else {
                                targetLabelIcon = 'fa fa-arrow-down'
                                targetGapValueColor = '#309143'
                            }
                            // targetGapValueColor = isPositive ? '#ff0000' : '#309143'
                        }
                    } else if (targetGapValue > 0) {
                        targetLabel = 'Below Target :'
                        if (isPositive) {
                            targetLabelIcon = 'fa fa-arrow-down'
                            targetGapValueColor = '#ff0000'
                        } else {
                            targetLabelIcon = 'fa fa-arrow-up'
                            targetGapValueColor = '#309143'
                        }
                        // } else if (upCase1 || upCase2) {
                    } else {
                        targetLabel = 'At Target :'
                        if (isPositive) {
                            targetLabelIcon = 'fa fa-arrow-up'
                            targetGapValueColor = '#309143'
                        } else {
                            targetLabelIcon = 'fa fa-arrow-down'
                            targetGapValueColor = '#ff0000'
                        }
                    }

                    actualValue = actualValue ? parseFloat(actualValue).toFixed(metricData.roundOff) : newActualValue ? newActualValue : null
                    // targetGapValue = targetGapValue ? targetGapValue.toFixed(metricData.roundOff) : 0
                    targetGapValue = targetGapValue ? number_shorten(Math.abs(targetGapValue), metricRoundOff, metricNumberShorten) : null
                    // planValue = planValue ? planValue.toFixed(metricData.roundOff) : 0
                    planValue = planValue ? number_shorten(planValue, metricRoundOff, metricNumberShorten) : null
                    growthValue = growthValue ? parseFloat(growthValue).toFixed(metricData.roundOff) : null
                    // LMValue = LMValue ? LMValue.toFixed(metricData.roundOff) : 0
                    LMValue = LMValue ? number_shorten(LMValue, metricRoundOff, metricNumberShorten) : null

                    if (planValue && planValue.split(' ')[0] == actualValue) {
                        targetLabelIcon = null
                        targetGapValueColor = null
                    }

                    LMValue = LMValue && metricData.metricUnit == '%' ? metricData.metricPrefix === 'true' ? metricData.metricUnit + ' ' + LMValue : LMValue + ' ' + metricData.metricUnit : LMValue
                    if (planValue && metricData.metricUnit == '%') {
                        if (metricData.metricPrefix === 'true') {
                            planValue = metricData.metricUnit + ' ' + planValue
                            targetGapValue = metricData.metricUnit + ' ' + targetGapValue
                        } else {
                            planValue = planValue + ' ' + metricData.metricUnit
                            targetGapValue = targetGapValue + ' ' + metricData.metricUnit
                        }
                    }
                    // planValue = planValue && metricData.metricUnit == '%' ? metricData.metricPrefix === 'true' ? metricData.metricUnit + ' ' + planValue : planValue + ' ' + metricData.metricUnit : planValue

                    // else if (targetGapValue > onePercentVal) {
                    //     targetLabel = 'Above Target :'
                    //     targetLabelIcon = <i data-feather="arrow-up"></i>
                    // }
                    // targetGapValueColor = targetGapValue > 0 ? 'text-danger' : 'text-success' 
                    // if (targetGapValue > 0) {
                    //     targetGapValueColor = 'text-danger'
                    // } else if (targetGapValue < 0) {
                    //     targetGapValueColor = 'text-success'
                    // }
                }
            })
            // var growth_class ='tx-medium tx-danger';
            // var value_sign_icon ='icon ion-md-arrow-down';
            var growthColor = null
            if (LMValue && LMValue.split(' ')[0] == actualValue) {
                growthColor = growthColor
            } else if (growthValue >= 0) {
                growthColor = '#309143'
            } else growthColor = '#ff0000'


            // growthValue = null // Prevent showing growth rate in Summary
            var growthInfo = growthValue ? <h7 className=''>{this.props.componentData && this.props.componentData.authData && this.props.componentData.authData.companyName == 'tvscredit' ? 'GOLM' : 'Growth Rate'}: <span style={{ color: growthColor }}>{growthValue}% </span> {LMValue ? <span className='text-secondary'>({LMValue})</span> : null}</h7> : null
            targetGapInfo = targetGapValue ? <h7 className=''>Variance: <span style={{ color: targetGapValueColor }}><i className={targetLabelIcon} aria-hidden="true"></i> {targetGapValue}{metricUnit}</span></h7> : null

            /* Start - New dynamic logic function to add extra metric info with dynamic Conditional formatting logic */
            let currentMetric = metricData?.value?.split(';')[0]
            currentMetric && Object.keys(shortNameObj[currentMetric]).map(function (innerKey) {
                var extraMetricObject = [], extraMetricValue = null, extraMetricColor = ''
                var extraMetricChildValue = null, metricDataValue = null;
                var checkTargetGap = innerKey == 'Target Gap' ? true : false
                var checkGrowth = ['Growth Rate', 'LM Growth', 'Growth'].indexOf(innerKey) > -1 ? true : false

                if (['Actual', 'Target Gap', 'LM Growth', 'Growth Rate', 'Growth', 'Previous Year', 'Last Month'].indexOf(innerKey) == -1) {
                    let shortNameValue = shortNameObj[currentMetric][innerKey]
                    extraMetricObject = metricPossibleCombinations.filter(function (innerData) {
                        if (innerData.value == shortNameValue)
                            return innerData
                    })

                    let parsedInfo = extraMetricObject[0] && isJson(extraMetricObject[0].information) ? JSON.parse(extraMetricObject[0].information) : {}
                    extraMetricColor = parsedInfo && parsedInfo['metricColor'] && !metricActualData
                        ? parsedInfo['metricColor']
                        : handleConditionalFormatting(metricActualData, parsedInfo, extraMetricObject.length > 0 ? extraMetricObject[0].value.split(';')[1] : '', backgroundColor, 'summary', null, null, checkTargetGap ? null : shortNameValue, checkTargetGap)

                    extraMetricValue = that.state.data.allData[shortNameValue]
                    let currentRoundOff = extraMetricObject[0] && extraMetricObject[0].roundOff ? extraMetricObject[0].roundOff : metricData.roundOff
                    let currentNumberShorten = extraMetricObject[0] && extraMetricObject[0].numberShorten ? extraMetricObject[0].numberShorten : metricData.numberShorten
                    extraMetricValue = extraMetricValue
                        ? checkGrowth
                            ? parseFloat(extraMetricValue).toFixed(currentRoundOff)
                            : number_shorten(checkTargetGap ? Math.abs(extraMetricValue) : extraMetricValue, checkTargetGap ? metricRoundOff : currentRoundOff, checkTargetGap ? metricNumberShorten : currentNumberShorten)
                        : null
                    if (extraMetricObject != undefined && extraMetricObject != null && extraMetricObject?.length > 0) {
                        if (extraMetricObject?.[0]?.value != null && extraMetricObject?.[0]?.value != undefined && extraMetricObject?.[0]?.value != "") {
                            extraMetricChildValue = extraMetricObject?.[0]?.value?.split(';')[0]
                        }
                    }
                    if (metricData?.value != undefined && metricData?.value != "") {
                        metricDataValue = metricData?.value?.split(';')[0]
                    }
                    var extraMetricFormat = extraMetricChildValue != null && metricDataValue != null && extraMetricChildValue == metricDataValue ? metricData?.metricUnit : extraMetricChildValue != null ? extraMetricObject?.[0]?.metricUnit : null;
                    if (extraMetricValue && extraMetricObject.length > 0) {
                        if (checkTargetGap) {
                            varianceInfo.push(<>
                                <h7>Variance:
                                    <span style={{ color: extraMetricColor }}> <i className={targetLabelIcon} aria-hidden="true"></i> {extraMetricValue}</span>
                                </h7>
                            </>)
                        } else {
                            extraMetricsInfo.push(<>
                                <h7>
                                    {checkGrowth
                                        ? 'Growth Rate:'
                                        : `${extraMetricObject[0].label}:`}
                                    <span style={{ color: extraMetricColor }}> {extraMetricValue}{extraMetricFormat}</span>
                                    {checkGrowth && LMValue ? <span className='text-secondary'> ({LMValue})</span> : null}
                                </h7>
                            </>)
                        }
                    }
                }
            })
            /* End */

        }

        /* Enabled CF of Actual Value */
        popover_config.html_data = <h3 className={`tx-normal tx-rubik tx-20 mg-b-2 mg-r-5 lh-1 ${pointerClass}`} style={{ color: !metricData ? 'red' : metricColor }}>{!metricData ? 'This metric is inactive.' : newDataFull}</h3>
        let tablet  = jQuery(window).width() >= mobile_width && jQuery(window).width() <= tablet_width  
        return (
            <div className={classBox} style={classBoxStyle} card="summary">

                {/* <Overlay show={this.state.show} target={() => ReactDOM.findDOMNode(this.target)} placement="right" container={this} containerPadding={20} >
                    <Popover id="popover-contained" title={title}>
                        {addition_data}
                   </Popover>
                </Overlay> */}

                < div className={this.props.recommendation ? "mg-t-5" : 'card card-body ht-120 mg-b-10'} id={'summarybox' + this.props.id} style={{ padding: this.props.recommendation ? '5px' : '10px' }}>
                    {/* <h6 className="tx-13 tx-spacing-1 tx-color-02 tx-semibold mg-b-8">{metric}</h6> */}
                    < h6 className="tx-uppercase tx-13 tx-spacing-1 tx-color-02 tx-semibold mg-b-5" > {metric}</h6 >
                    {/* Enable Right click for dashboard here*/}
                    {/* {this.props.index? null:trendChartIcon} */}
                    {trendChartIcon}
                    <div className="d-flex d-lg-block d-xl-flex align-items-end">

                        {/* <h3 className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">{newDataFull}</h3> */}

                        {popover_config.content ? <PopoverComponent config={popover_config} isDashboard={this.props.index} /> :popover_config.html_data}

                        <p className="tx-11 tx-color-03 mg-b-0" id={"growth_style_" + this.props.id}>
                            {/* <span className={growthStyle + " tx-medium"}>{growth}</span> */}
                            {/* <span className="tx-medium tx-success">{growth}</span> */}
                            {this.props.index ? null : growth}
                            {/* {additional_table} */}

                            {/* <span className={growthStyle+" tx-medium"}>{absoluteFull}</span> */}
                        </p>
                    </div>
                    <div className="d-flex flex-column">
                        {targetGapInfo}
                        {growthInfo}
                        {/* {varianceInfo} */}
                        {extraMetricsInfo}
                    </div>
                </div >
                {/* <h6 className="tx-12 tx-spacing-1 tx-color-02 mg-b-8">
                        {metric}
                        {additional_table}
                    </h6> */}
                {/* <span className='metricTitle'>
                        {metric}
                        {additional_table}
                    </span> */}

            </div >

            // </div>
        );
    }
};

function calculateOnePercent(value) {
    return (1 / 1000) * value // Multiplying value by 0.1%
}


export default SummaryMessage;